import React, { useState } from 'react';
import './styles/featuredProducts.scss';
import { MdOutlineShoppingBag } from 'react-icons/md';
import { MdFavoriteBorder } from 'react-icons/md';
import productsData from '../productsData';

function FeaturedProducts() {
    let allProducts = productsData;

    const [products, setProducts] = useState(allProducts);

    let furnitureProducts = allProducts.filter(
        (product) => product.category === 'furniture'
    );
    let decorationProducts = allProducts.filter(
        (product) => product.category === 'decoration'
    );
    let textileProducts = allProducts.filter(
        (product) => product.category === 'textile'
    );

    const handleCategorySelect = (e) => {
        //let selectedCategory = document.querySelector('.category-selected');
        let allCategories = document.querySelectorAll('.category-item');

        // usuwanie klasy z pozostałych kategorii i dodawanie stanu aktywności do klikniętego elementu
        Array.from(allCategories).forEach((element) => {
            element.classList.remove('category-selected');
        });
        e.target.classList.add('category-selected');
    };

    return (
        <section className='featuredProducts'>
            <h1>FEATURED PRODUCTS</h1>
            <p className='description'>
                Select a cathegory using special switches or go to the section
                with a convenient filter by product
            </p>

            <div className='categories-container'>
                <div
                    className='category-item category-selected'
                    onClick={(e) => {
                        handleCategorySelect(e);
                        setProducts(allProducts);
                    }}
                >
                    ALL PRODUCTS
                </div>
                <div
                    className='category-item'
                    onClick={(e) => {
                        handleCategorySelect(e);
                        setProducts(furnitureProducts);
                    }}
                >
                    FURNITURE
                </div>
                <div
                    className='category-item'
                    onClick={(e) => {
                        handleCategorySelect(e);
                        setProducts(decorationProducts);
                    }}
                >
                    DECORATION
                </div>
                <div
                    className='category-item'
                    onClick={(e) => {
                        handleCategorySelect(e);
                        setProducts(textileProducts);
                    }}
                >
                    TEXTILE
                </div>
            </div>

            <section className='products-cards-wrapper'>
                {products.map(
                    ({ productName, productPrice, image, productId }) => (
                        <div className='product-card'>
                            <div
                                onClick={() =>
                                    (document.location.href = `/my-home/#/product/${productName
                                        .split(' ')
                                        .join('')}/${productId}`)
                                }
                                className='product-card-image'
                                style={{
                                    backgroundImage: `url('${process.env.PUBLIC_URL}/${image}')`,
                                }}
                            >
                                <span>
                                    <MdFavoriteBorder />
                                </span>
                            </div>
                            <div className='product-card-description'>
                                <div className=''>
                                    <p className='product-name'>
                                        {productName}
                                    </p>
                                    <p className='product-price'>
                                        ${productPrice}
                                    </p>
                                </div>
                                <MdOutlineShoppingBag className='product-card-icon' />
                            </div>
                        </div>
                    )
                )}
            </section>

            <p className='show-more'>SHOW MORE</p>
        </section>
    );
}

export default FeaturedProducts;
